import { type CarrierDef } from '../common.js'
import { password, username, userPassMap } from '../internal.js'

const credentialTypes = [username, password] as const

export type edxiCredType = (typeof credentialTypes)[number]
export const edxi: CarrierDef<edxiCredType> = {
  name: 'EDI Express',
  scac: 'edxi',
  credentialTypes,
  legacyCredMap: [...userPassMap],
  engineLayers: ['rating', 'pickup', 'tracking'],
}
